import React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

const AutoSelect = (props) => {
    if(props.data.length <= 0){
        return(
            <TextField size='small' disabled label={props.label} />
        );
    } else{
        return(
            <Autocomplete
                id={props.id}
                size='small'
                options={props.data}
                getOptionLabel={props.getOptionLabel ?  (option) => props.getOptionLabel(option) : (option) => option.label}
                defaultValue={props.value !== null ? props.value : null}
                sx={{ width: props.width ? props.width : '100%' }}
                renderOption={props.renderOption ? props.renderOption : (props, option) => (<div {...props}>{option.label}</div>)}
                renderInput={(params) => {
                    return <TextField {...params} label={props.label} />;
                }}
                onChange={props.onChange ? (e, value) => props.onChange(value) : (e, value) => {}}
            />
        );
    }
}

export default AutoSelect;